export const saveSvgAsPdf = (el: SVGSVGElement, name: string) =>
	import('util/svg2pdf')
		.then(({default: save}) => save(el, name))
		.catch((err) => console.error(err))

export const saveSvgAsPng = (el: SVGSVGElement, name: string) =>
	import('util/svg2png')
		.then(({default: save, toBlob}) => {
			toBlob(el)
				.then((uri) => {
					window.open(URL.createObjectURL(uri), '_blank')
				})
				.catch((err) => console.error(err))
			save(el, name)
		})
		.catch((err) => console.error(err))

export const saveSvgAsPngBlob = (el: SVGSVGElement) =>
	import('util/svg2png')
		.then(({toBlob}) => toBlob(el))
		.catch((err) => console.error(err))
